import type CreditExposureState from "../creditExposureState";

export default class CreditExposuresFilter {
  distributorId: string;
  state?: CreditExposureState;
}
